import { useEffect, useState } from 'react'
import { apiJson } from '../../lib/api'
import { BilingualField, Field, ui } from './shared'
import { MediaPicker } from './MediaPicker'

type HeroRow = {
  eyebrow_it: string; eyebrow_en: string;
  title: string;
  lead_it: string; lead_en: string;
  intro_it: string; intro_en: string;
  member_line: string;
  image_key: string;
  cta_primary_it: string; cta_primary_en: string;
  cta_secondary_it: string; cta_secondary_en: string;
}

const empty: HeroRow = {
  eyebrow_it: '', eyebrow_en: '', title: 'Áncreus',
  lead_it: '', lead_en: '', intro_it: '', intro_en: '',
  member_line: '', image_key: '',
  cta_primary_it: '', cta_primary_en: '',
  cta_secondary_it: '', cta_secondary_en: '',
}

export function HeroEditor() {
  const [row, setRow] = useState<HeroRow>(empty)
  const [loading, setLoading] = useState(true)
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    apiJson<{ hero: HeroRow | null }>('/api/admin/hero')
      .then((r) => setRow({ ...empty, ...(r.hero ?? {}) }))
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false))
  }, [])

  async function save() {
    setError(null); setMsg(null); setBusy(true)
    try {
      await apiJson('/api/admin/hero', { method: 'PUT', body: JSON.stringify(row) })
      setMsg('Salvato.')
    } catch (err) { setError(String(err)) }
    finally { setBusy(false) }
  }

  if (loading) return <div style={{ color: 'var(--fg-muted)' }}>Carico…</div>

  return (
    <div>
      <h1 style={ui.sectionTitle}>Hero</h1>
      <div style={{ ...ui.card, display: 'flex', flexDirection: 'column', gap: 18 }}>
        <Field label="Titolo grande (es. Áncreus)">
          <input style={ui.input} value={row.title}
                 onChange={(e) => setRow({ ...row, title: e.target.value })} />
        </Field>
        <BilingualField label="Eyebrow (riga piccola sopra il titolo)"
          valueIt={row.eyebrow_it} valueEn={row.eyebrow_en}
          onItChange={(v) => setRow({ ...row, eyebrow_it: v })}
          onEnChange={(v) => setRow({ ...row, eyebrow_en: v })} />
        <BilingualField label="Lead (frase corsiva sotto il titolo)"
          valueIt={row.lead_it} valueEn={row.lead_en}
          onItChange={(v) => setRow({ ...row, lead_it: v })}
          onEnChange={(v) => setRow({ ...row, lead_en: v })}
          multiline />
        <BilingualField label="Intro (paragrafo)"
          valueIt={row.intro_it} valueEn={row.intro_en}
          onItChange={(v) => setRow({ ...row, intro_it: v })}
          onEnChange={(v) => setRow({ ...row, intro_en: v })}
          multiline />
        <Field label="Riga membri (es. Giorgia Bruno · Diego Cavallero · Alberto Calandri)">
          <input style={ui.input} value={row.member_line}
                 onChange={(e) => setRow({ ...row, member_line: e.target.value })} />
        </Field>
        <Field label="Immagine di sfondo (full-bleed)">
          <MediaPicker value={row.image_key} onChange={(v) => setRow({ ...row, image_key: v })} />
        </Field>
        <BilingualField label="CTA primaria"
          valueIt={row.cta_primary_it} valueEn={row.cta_primary_en}
          onItChange={(v) => setRow({ ...row, cta_primary_it: v })}
          onEnChange={(v) => setRow({ ...row, cta_primary_en: v })} />
        <BilingualField label="CTA secondaria"
          valueIt={row.cta_secondary_it} valueEn={row.cta_secondary_en}
          onItChange={(v) => setRow({ ...row, cta_secondary_it: v })}
          onEnChange={(v) => setRow({ ...row, cta_secondary_en: v })} />

        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" style={ui.btn} disabled={busy} onClick={save}>
            {busy ? '…' : 'Salva'}
          </button>
          {msg && <span style={{ alignSelf: 'center', color: 'var(--fg-soft)', fontSize: 13 }}>{msg}</span>}
          {error && <span style={{ alignSelf: 'center', color: '#a33' }}>{error}</span>}
        </div>
      </div>
    </div>
  )
}
